export default "__VITE_ASSET__Cg7iKUHO__"